class ProductCardReview extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setAttribute('aria-hidden', 'true')
    this.setupObserver()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.observer.disconnect()
  }

  /**
   * Sets up a MutationObserver to watch for changes in the target element. Calls
   * the formatReviewCount function whenever changes are detected.
   *
   * @function observer
   */
  setupObserver () {
    this.observer = new MutationObserver(() => {
      this.formatReviewCount()
    })

    this.observer.observe(this, {
      childList: true,
      subtree: false,
    })
  }

  formatReviewCount () {
    const countEl = this.querySelector('.text-m')
    if (!countEl) return

    const reviewCount = Number(countEl.textContent?.split(' ')?.[0] || 0)
    this.setAttribute('aria-hidden', reviewCount === 0)
    countEl.textContent = reviewCount
  }
}

if (!customElements.get('product-card-review')) {
  customElements.define('product-card-review', ProductCardReview)
}
